import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import { useMemo } from 'react';
import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { QuestionType } from '@module/form';
import { styleVariables, AudioPlayerV2, MathEnabledTextComponent, getSize, getColor } from '@lib/common';
import { useQuestionContext } from '../../question-v2/core';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var MainLayout = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 32px 24px;\n  border-radius: 12px;\n  box-shadow: 0px 3px 6px ", ";\n  background: ", ";\n  overflow: hidden;\n"])), styleVariables.colors.transparentGray6, styleVariables.colors.gray1);
var ContentWrapper = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  &.last-content {\n    margin-bottom: 0;\n  }\n"])));
var StyledQuestionHeader = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n"])));
var QuestionContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
var QuestionContentTitle = styled(MathEnabledTextComponent)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n\n  color: ", ";\n  img {\n    max-width: 100%;\n  }\n\n  p {\n    margin-bottom: 0;\n  }\n"])), styleVariables.colors.gray13);
var AudioWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin: 0 8px;\n"])));
var StyledQuestionNumberTag = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n"])), getSize('padding4'), getSize('padding8'), getSize('typo14'), getSize('typo20'), getColor('fillIntActive'), getSize('radiusS'));
var StyledQuestionScoreTag = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n\n  gap: ", ";\n\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  border-radius: 999px;\n  border: 1px solid #e5e7eb;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('padding8'));
var StyledQuestionTypeTag = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n\n  gap: ", ";\n\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  border-radius: 999px;\n  border: 1px solid #e5e7eb;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('padding8'));
export var BaseQuestionAnswerComponent = function BaseQuestionAnswerComponent(_ref) {
  var _audioFileRule$isAllo, _audioFileRule$allowi;

  var states = _ref.states,
      _questionActions = _ref.actions,
      children = _ref.children;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var index = states.index,
      label = states.label,
      audioPlayerLabels = states.audioPlayerLabels,
      hasCustomDescription = states.hasCustomDescription,
      icon = states.icon;
  var jsonAudioFile = question === null || question === void 0 ? void 0 : question.audioFile;
  var audioFileRule = jsonAudioFile === null || jsonAudioFile === void 0 ? void 0 : jsonAudioFile.rule;
  var questionId = question === null || question === void 0 ? void 0 : question.id.toString();
  var questionTypeTagLabel = useMemo(function () {
    var _questionTypeTagLabel;

    var questionTypeTagLabelMapping = (_questionTypeTagLabel = {}, _defineProperty(_questionTypeTagLabel, QuestionType.SingleChoice, (label === null || label === void 0 ? void 0 : label.singleChoice) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.FillInBlank, (label === null || label === void 0 ? void 0 : label.fillInBlank) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.Matching, (label === null || label === void 0 ? void 0 : label.matching) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.Essay, (label === null || label === void 0 ? void 0 : label.essay) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.MultipleChoice, (label === null || label === void 0 ? void 0 : label.multipleChoice) || ''), _questionTypeTagLabel);
    return questionTypeTagLabelMapping[question.type] || 'Unknown';
  }, [question.type, label]);
  return /*#__PURE__*/_jsxs(MainLayout, {
    direction: "vertical",
    size: "middle",
    id: "form-".concat(question.id.toString()),
    children: [/*#__PURE__*/_jsx(StyledQuestionHeader, {
      id: "qp_".concat(index),
      children: /*#__PURE__*/_jsxs(Space, {
        size: 12,
        children: [/*#__PURE__*/_jsxs(StyledQuestionNumberTag, {
          children: [label.question, " ", question.titleIndex]
        }), /*#__PURE__*/_jsxs(StyledQuestionScoreTag, {
          children: [icon.star, /*#__PURE__*/_jsxs("span", {
            children: [question.score, " ", label.score]
          })]
        }), /*#__PURE__*/_jsxs(StyledQuestionTypeTag, {
          children: [icon.pointFocus, /*#__PURE__*/_jsx("span", {
            children: questionTypeTagLabel
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      direction: "vertical",
      children: [!hasCustomDescription && /*#__PURE__*/_jsx(QuestionContent, {
        children: /*#__PURE__*/_jsx(QuestionContentTitle, {
          value: question.description
        })
      }), jsonAudioFile && /*#__PURE__*/_jsxs(AudioWrapper, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            marginBottom: '8px',
            color: '#666'
          },
          children: (label === null || label === void 0 ? void 0 : label.audio) || 'Audio'
        }), /*#__PURE__*/_jsx(AudioPlayerV2, {
          source: jsonAudioFile.url,
          audioId: "question-".concat(questionId),
          audioPlayerConfig: {
            isAllowedToReplay: (_audioFileRule$isAllo = audioFileRule === null || audioFileRule === void 0 ? void 0 : audioFileRule.isAllowedToReplay) !== null && _audioFileRule$isAllo !== void 0 ? _audioFileRule$isAllo : false,
            isAllowedToPause: (_audioFileRule$allowi = audioFileRule === null || audioFileRule === void 0 ? void 0 : audioFileRule.allowingToPauseAndStop) !== null && _audioFileRule$allowi !== void 0 ? _audioFileRule$allowi : false,
            numberOfReplays: +(audioFileRule === null || audioFileRule === void 0 ? void 0 : audioFileRule.numberOfReplays.value) || -1
          },
          labels: audioPlayerLabels
        })]
      }), /*#__PURE__*/_jsx(QuestionContent, {
        children: children
      })]
    })]
  });
};